// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all training
export const viewTraining = createAsyncThunk(
  "training",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}born-to-win-api/training`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// List only approved training
export const approvedTrainingList = createAsyncThunk(
  "training",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/paginate-training`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// Add new Training
export const addTraining = createAsyncThunk(
  "training",
  async (trainingData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}born-to-win-api/training`,
        trainingData
      );
      console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Search Training by ID
export const singleTraining = createAsyncThunk(
  "training",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/training/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search Training ...");
    }
  }
);

// Update Training
export const updateTraining = createAsyncThunk(
  "training",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/training/${id}`,
        formData
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Delete Training
export const deleteTraining = createAsyncThunk(
  "training",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}born-to-win-api/training/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Single User training
export const singleUserTraining = createAsyncThunk(
  "training",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/users-training/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search training history...");
    }
  }
);

// Approve Training
export const approveTraining = createAsyncThunk(
  "training",
  async (trainingData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/training-approve/${trainingData.id}`,
        trainingData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Approved successfully!");
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        "Please try again. Invalid credentials"
      );
    }
  }
);
